// IMPORTANT: This file needs to imported before any components are loaded otherwise the hooks won't be registered
// for those components
import "./class-component-hooks";

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import Vue from "vue";

import VueGtm from "@gtm-support/vue2-gtm";

import App from "./App.vue";
import { registerFilters } from "./filters";
import NativeAppPlugin, { NativeAppOptions } from "./plugins/native-app/install";
import StoragePlugin from "./plugins/storage";
import router from "./router";
import appInsights, { logError, SeverityLevel } from "./utils/appInsights";
import { StartRefreshInterval } from "./utils/eventBus";
import gateway, { GatewayImpl } from "./utils/gateway";

// Initialize App Insights
// appInsights.loadAppInsights();
// appInsights.trackPageView();

Vue.config.productionTip = false;

// Need to initialize the router (see the comments on the gateway's router property for the reason why)
(gateway as GatewayImpl).router = router;

// Register plugins
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(StoragePlugin);
Vue.use(NativeAppPlugin, { router: router } as NativeAppOptions);

// Register Google Tag Manager
// Vue.use(VueGtm, {
//   id: "GTM-58P2SZS",
//   defer: false,
//   compatibility: false,
//   nonce: "2726c7f26c",
//   enabled: true,
//   debug: true,
//   loadScript: true,
//   vueRouter: router,
//   trackOnNextTick: false
// });

registerFilters(Vue);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

StartRefreshInterval();
Vue.config.errorHandler = (err: any, vm, info) => {
  // If the unhandled error was already handled by redirecting the user (see gateway.ts), then don't redirect them to
  // the error page
  if (err?.isHandled) return;

  logError(vm, err, SeverityLevel.Critical, {
    message: "Unhandled error",
    info: info
  });

  // Send the user to the error page
  router.push("/error");
};
